import React, { useMemo, useState } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

import { SideNavContext } from './SideNavContext';
import type { SideNavState } from './SideNavState';

type SideNavProviderProps = {
	children: React.ReactNode;
};

const StabilizedSideNavContextProvider = ({
	children,
	isSideNavOpen,
	setSideNavOpen,
}: SideNavProviderProps & SideNavState): React.JSX.Element => {
	const value = useMemo(() => ({ isSideNavOpen, setSideNavOpen }), [isSideNavOpen, setSideNavOpen]);

	return <SideNavContext.Provider value={value}>{children}</SideNavContext.Provider>;
};

const InlineSideNavContextProvider = ({
	children,
	isSideNavOpen,
	setSideNavOpen,
}: SideNavProviderProps & SideNavState): React.JSX.Element => (
	<SideNavContext.Provider value={{ isSideNavOpen, setSideNavOpen }}>
		{children}
	</SideNavContext.Provider>
);

export const SideNavProvider = ({ children }: SideNavProviderProps): React.JSX.Element => {
	const [isSideNavOpen, setSideNavOpen] = useState(false);

	return FeatureGates.getExperimentValue<boolean>(
		'rovo_ttai_segment_render_stabilization',
		'isEnabled',
		false,
	) === true ? (
		<StabilizedSideNavContextProvider isSideNavOpen={isSideNavOpen} setSideNavOpen={setSideNavOpen}>
			{children}
		</StabilizedSideNavContextProvider>
	) : (
		<InlineSideNavContextProvider isSideNavOpen={isSideNavOpen} setSideNavOpen={setSideNavOpen}>
			{children}
		</InlineSideNavContextProvider>
	);
};
